import { BaseComponent } from '../../components/base-component'
import { CartDrawer } from './cart-drawer'
import { $el, $elParent } from 'src/scripts/utils/utils'

const CART_DRAWER_SELECTOR = 'cart-drawer'
const CHECKOUT_BUTTON_SELECTOR = '[data-cart-checkout-button]'

export class CartDrawerButtonsBlock extends BaseComponent {
  mountComponent(): void {
    const cartDrawer: CartDrawer = $elParent(CART_DRAWER_SELECTOR, this)
    cartDrawer?.on('start-update', this.handleStartCartUpdate)
    cartDrawer?.on('stop-update', this.handleCartUpdate)
    cartDrawer?.on('update-nodes', this.handleCartUpdate)
  }

  unmountComponent(): void {
    const cartDrawer: CartDrawer = $elParent(CART_DRAWER_SELECTOR, this)
    cartDrawer?.off('start-update', this.handleStartCartUpdate)
    cartDrawer?.off('update-nodes', this.handleCartUpdate)
  }

  handleStartCartUpdate = (): void => {
    this.setLoading(true)
  }

  handleCartUpdate = (): void => {
    this.setLoading(false)
  }

  setLoading(isLoading: boolean): void {
    const button = $el(CHECKOUT_BUTTON_SELECTOR, this)
    button?.toggleAttribute('disabled', isLoading)
    button?.classList.toggle('loading', isLoading)
  }
}
